import appConfig from '@/config';

const LogoPng = (organizationId) => {
  const fromConfigFile = appConfig['assine'];

  return fromConfigFile.baseURL + `/logo.png?organization=${organizationId}`;
};

export default LogoPng;
